import { Box, Flex, Image, Button, HStack, Link } from "@chakra-ui/react";
import React from "react";
import logo from "../images/logo.png";
import { AiFillTwitterCircle } from "react-icons/ai";
import { BsTelegram } from "react-icons/bs";

const Header = () => {
  return (
    <div>
      <Flex
        position="static"
        mt="10px"
        w="100%"
        alignItems="center"
        justifyContent="center"
      >
        <Box
          bg="#171719"
          pl="20px"
          pr="20px"
          pt="10px"
          pb="10px"
          borderRadius="40px"
          w={{ base: "80%", md: "50%" }}
        >
          <Flex alignItems="center" justifyContent="space-between">
            <HStack>
              <Box>
                <Image src={logo} boxSize="35px" borderRadius="300px" />
              </Box>
              <Box
                display={{ base: "none", md: "flex" }}
                fontWeight="600"
                fontSize="18px"
              >
                ChainPulse
              </Box>
            </HStack>

            <HStack>
              <Link
                href="https://twitter.com/ChainPulseSOL/"
                isExternal
                _hover={{ textDecoration: "none" }}
              >
                {" "}
                <Box>
                  <AiFillTwitterCircle />
                </Box>
              </Link>
              <Link
                href="https://t.me/chainpulseapp"
                isExternal
                _hover={{ textDecoration: "none" }}
              >
                {" "}
                <Box>
                  <BsTelegram />
                </Box>
              </Link>
              <Link href="/start" _hover={{ textDecoration: "none" }}>
                <Button size="sm" borderRadius="10px">
                  Start tracking
                </Button>
              </Link>
            </HStack>
          </Flex>
        </Box>
      </Flex>
    </div>
  );
};

export default Header;
